import React, { useEffect, useRef } from "react";

function SubdivisionDesignation({
  position,
  validationError,
  handleChangeDesignationName,
  subdivision,
  setShowDescription,
  handleUpdateDesignation,
  handleShowDescription,
  handleSetEditDesignation,
  handleDeleteDesignation,
  showDescription,
  hasDesignationPermission,
}) {
  const designationRef = useRef();

  useEffect(() => {
    if (designationRef.current) {
      designationRef.current.style.height = "100%";
      const scrollHeight = designationRef.current.scrollHeight;
      designationRef.current.style.height = scrollHeight + "px";
    }
  }, [position]);

  return (
    <li key={`designation${position.id}`}>
      <div
        className={
          !validationError?.level && validationError?.id === position.id
            ? "add-to-list-input-wrapper unit-error-border"
            : "add-to-list-input-wrapper"
        }
      >
        <textarea
          ref={designationRef}
          rows="1"
          autoFocus
          style={{ resize: "none", overflow: "hidden" }}
          readOnly={!position.typing && !position.editing}
          type="text"
          className="add-to-list-input"
          value={position?.name}
          onChange={(e) =>
            handleChangeDesignationName(
              e,
              position.id,
              subdivision.id,
              "subdivisions",
              "name"
            )
          }
          // onKeyDown={(e) =>
          //   handleKeyDown(e, handleAddConfirmPositionToDepartment, department.id, position.id)
          // }
          // onBlur={() => {
          //   position.name
          //     ? handleAddConfirmPositionToDepartment(department.id, position.id)
          //     : handleDeletePositionFromDepartment(department.id, position.id);
          // }}
        ></textarea>

        <div className="edit-buttons-block">
          {(position?.typing || position.editing) && position?.name && (
            <button
              onClick={() => {
                setShowDescription(null);
                handleUpdateDesignation({
                  ...position,
                  level: 3,
                });
              }}
            >
              <img src="/images/check1.jpg" />
            </button>
          )}
          {!position?.typing &&
            !position.editing &&
            position?.name &&
            hasDesignationPermission && (
              <button
                onClick={() => {
                  handleShowDescription(position.id, 3, true);
                  handleSetEditDesignation(
                    position.id,
                    subdivision.id,
                    "subdivisions",
                    3
                  );
                }}
              >
                <img src="/images/edit.png" />
              </button>
            )}
          {hasDesignationPermission && (
            <button
              onClick={() =>
                handleDeleteDesignation(
                  { id: position.id, level: 3 },
                  "designation"
                )
              }
            >
              <img src="/images/trash.png" />
            </button>
          )}
          {!position.adding && (
            <button onClick={() => handleShowDescription(position.id, 3)}>
              <img
                alt=""
                src={
                  showDescription &&
                  showDescription.id === position.id &&
                  showDescription.level === 3
                    ? "/images/iks.png"
                    : "/images/plus.png"
                }
              />
            </button>
          )}
        </div>
      </div>
      {showDescription &&
        showDescription.id === position.id &&
        showDescription.level === 3 && (
          <textarea
            rows="4"
            cols="50"
            className="position-description"
            value={position.description || ""}
            readOnly={!position.editing}
            onChange={(e) =>
              handleChangeDesignationName(
                e,
                position.id,
                subdivision.id,
                "subdivisions",
                "description"
              )
            }
          />
        )}
    </li>
  );
}

export default SubdivisionDesignation;
